import React, { useState } from 'react'
import Navbar from '../inc/Navbar'
import ScrollToTop from "react-scroll-to-top"
import { Link } from "react-router-dom";
import { Typewriter } from 'react-simple-typewriter'
import Callback from './Callback';
import ShiftingProcess from './ShiftingProcess';
import WorkProcess from './WorkProcess';
import helpdeskdetails from "../images/Helpdesk.jpg";
import Contactform from './Contactfrom';
import Table from 'react-bootstrap/Table';

import moverstime from "../images/iba approved  packers movers.jpg";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import sbilogo from "../images/sbi_logo.jpg";
import Callfrom from './Callfrom';

function IbaApproved() {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 3
  };


  return (
    <div>
      <Navbar />
      <br />
      <br />
      <br />
      <br />

      <ScrollToTop smooth top="100" color="Gray" />
      <div className='packermovershoogle'>
        <div className="album py-0">

          <div className="container mt-3">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item"><Link to="/" href="#"><small>Home</small></Link></li>
                <li className="breadcrumb-item active" aria-current="page"><small>IBA Approved Packers Movers</small></li>
              </ol>
            </nav>
          </div>
        </div>
      </div>

      <div style={{
        backgroundImage: "url(" + "https://i.postimg.cc/c4Hz6v94/IBA-PAGE.jpg" + ")",
        backgroundPosition: 'start',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat'
      }}>
        <div className="album py-1">
          <div className="container">
            <div className="row">
              <div className="col-md-8 mt-3">
                <button className='iba'>IBA Approved Packers and Movers</button>
                <h1 style={{ fontSize: "3rem", color: "white" }} className="card-text mb-4"> <b>Best Home Shifting Services in Kolkata</b></h1>

  <br />
      <br />
      <br />
      <br />
        <br />
      <br />
      <br />
      <br />
        <br />
      <br />
      <br />
      <br />

                <h6 style={{ color: "white" }} className="card-text mb-5"> We have 35+ years of robust experience to smoothen your home moving experience</h6>
                <h3 className="card-text " style={{ margin: "auto 0", color: "white" }}> <b>   <span style={{ fontWeight: "bold", marginleft: '10px', color: "white" }}>
                  <Typewriter
                    loop
                    cursor
                    cursorStyle="_"
                    typeSpeed={100}
                    deleteSpeed={50}
                    delaySpeed={1000}
                    words={["IBA APPROVED PAVKERS AND MOVERS"]}
                  />
                </span>
                </b></h3>
                <div className="indiastrustedwebsitedevelopment">
                  <h3 style={{ fontSize: "1rem", color: "white" }} className="card-text mb-8 mt-2"> <b>AT INDIA PACKERS AND MOVERS
</b></h3>
                </div>
              </div>
              <div className="col-md-4 mt-3">
                <div className='packer_Rajarhatkolkata'>
                  <Contactform />
                </div>
              </div>
            </div>
          </div>
        </div>
        <br />
        <br />
        <br />



      </div>


      <div className="album py-1">
          <div className="container">
            <div className="row">
              <div className="col-md-7 mt-3">
           <h2 className='mb-2'>PAN INDIA Service</h2>
           <h1>AT India Packers and Movers</h1>
           <h6 className='justify'>Affordable Packers and Movers in <b> IBA Approved</b> – Get reliable, professional, and budget-friendly relocation services for a smooth move to or from IBA Approved.

Looking for trusted packers and movers in IBA Approved? We provide hassle-free shifting services with top-quality packing and on-time delivery.

Professional relocation services in IBA Approved at competitive rates – ensuring your move is safe, quick, and stress-free.

Choose our expert packers and movers in IBA Approved for seamless local and long-distance shifting with maximum convenience.

We deliver efficient and affordable moving services in IBA Approved designed to exceed your expectations every time.

Experience hassle-free packing and moving in IBA Approved with our skilled team and customized relocation solutions.

Our IBA Approved packers and movers ensure safe transportation of your belongings with professional care and precision.</h6>
              </div>
              <div className="col-md-5 mt-4">
                <div className="card" >
                  <img src={moverstime} className="card-img-top" alt="moverstime"/>
                  
                </div>

              </div>
            </div>
          </div>
        </div>

      <div className='grey'>
        <br />
        <div className="album py-1">

          <div className="container">
            <center><h2 style={{ color: "#05438e" }}>How does it Work?</h2></center>
          </div>
        </div>
        <div className="album py-1">
          <div className="container">
            <div className="row">
              <div className="col-md-8 mt-3">
                <WorkProcess />
              </div>
              <div className="col-md-4 mt-4">
                <div className="card" >
                  <img src={helpdeskdetails} className="card-img-top" alt="helpdeskdetails" />
                  <div className="card-body">
                    <h5 style={{ color: "#05438e" }} className="card-title"><center>Helpful Details</center></h5>
                    <p className="card-text">Packing tips</p>

                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
        <br />
        <br />

      </div>
   
      <div className='homeshiftprice'>
           <br />
      <div className="container">
        <div className='welcometext'>
          <h1 className="card-title mb-0"><b>Check Our Affordable House Shifting Prices Below:

          </b></h1>
          <div className="col-md-10">
            <hr style={{ color: "#1D4D93" }} />
          </div>
        </div>
      </div>
      <div className="animat">
        <Slider {...settings}>

          <div>

            <div className="card mb-12">
              <Table striped bordered hover variant="light">
                <thead>
                  <tr>
                    <th style={{ color: "#0439b5ff" }}>Move Type/Distance	</th>
                    <th style={{ color: "#0335aaff" }}>100 - 350 km</th>
                    <th style={{ color: "#032062" }}>350 - 750 km</th>
                    <th style={{ color: "#032062" }}>750 - 1200 km</th>
                    <th style={{ color: "#032062" }}>1200 - 1700 km</th>
                    <th style={{ color: "#032062" }}>1700 - 2300 km	</th>
                    <th style={{ color: "#032062" }}>2300 - 3000 km</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>1 BHK</td>
                    <td>Rs. 11,000 - 21,000</td>
                    <td>	Rs. 13,500 - 22,500</td>
                    <td>Rs. 15,500 - 25,500</td>
                    <th>Rs. 18,500 - 27,000</th>
                    <th>Rs. 21,000 - 30,000</th>
                    <th>Rs. 23,500 - 36,700</th>


                  </tr>
                  <tr>
                    <td>2 BHK</td>
                    <td>Rs. 15,000 - 25,000</td>
                    <td>Rs. 17,500 - 28,500</td>
                    <td>Rs. 20,000 - 31,000</td>
                    <th>Rs. 23,000 - 36,000</th>
                    <th>Rs. 27,000 - 40,000</th>
                    <th>Rs. 29,300 - 46,000</th>

                  </tr>
                  <tr>
                    <td>3 BHK</td>
                    <td >Rs. 18,000 - 30,000</td>
                    <td>Rs. 21,000 - 34,000	</td>
                    <td>Rs. 23,500 - 38,000</td>
                    <th>Rs. 27,500 - 42,000</th>
                    <th>Rs. 32,000 - 48,000</th>
                    <th>Rs. 35,000 - 55,500</th>

                  </tr>




                  <tr>
                    <td>4+ BHK/Villa</td>
                    <td> Rs. 22,500 - 34,500</td>
                    <td>Rs. 26,000 - 39,000	</td>
                    <td>Rs. 29,000 - 45,000	</td>
                    <th>Rs. 34,000 - 47,500</th>
                    <th>Rs. 38,000 - 55,000</th>
                    <th>Rs. 41,000 - 60,000</th>


                  </tr>





                </tbody>
              </Table>

            </div>

          </div>

          <div>
            
           
          </div>

       


          
          
          <div>
        
          </div>




        </Slider>
      </div>
<br />
<br/>
</div>

<div className="album py-1">
          <div className="container">
            <h1 style={{color:"#05438e"}} className='mt-2'><b>IBA Approved packers movers near me</b></h1>
            <p style={{color:"#05438e"}}>If you are searching for ‘Packers Movers near me’, then no worries — you will find AT INDIA PACKERS MOVERS as the top choice on Google, trusted by customers for our quality shifting services near you.</p>
            <h1 style={{color:"#05438e"}}><b>Best IBA Approved packers movers in India</b></h1>
            <p style={{color:"#05438e"}}>IBA Approved Packers and Movers – AT India Packers and Movers is trusted by individuals, businesses, corporates, and government organizations across the region. With a perfect blend of professionalism, dedication, and teamwork, we ensure safe, reliable, and hassle-free relocation services every time.</p>
            
                   <button type="button" className="whatsapp mt-2" data-bs-toggle="modal" data-bs-target="#exampleModal">
                      REQUEST CALL BACK
                    </button>

                    <div className="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                      <div className="modal-dialog">
                        <div className="modal-content">
                          <div className="modal-header">
                            <h5 className="modal-title packersmoverswebsite" id="exampleModalLabel">AT INDIA PACKERS</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                          </div>
                          <div className="modal-body">
                            <Callfrom/>
                          </div>
                          <div className="modal-footer">
                            <button type="button" className="close" data-bs-dismiss="modal">Close</button>

                          </div>
                        </div>
                      </div>
                    </div>
                    <br/>
                    <br/>
            </div>
          </div>

      
      <ShiftingProcess />


      <Callback />


    </div>
  )
}

export default IbaApproved